export * from './deprecated-events-definition'
import * as NEWPropertyOwnershipEvents from './events-definition'
export { NEWPropertyOwnershipEvents }
